import React, { useEffect, useState } from 'react';
import ListItemText from '@material-ui/core/ListItemText';
import { FormLabel, makeStyles, Popover, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import Drawer from '@material-ui/core/Drawer';
import InstrumentSelect from './InstrumentSelect';
import QuantityBasisSelect from './QuantityBasisSelect';
import OptionDirectionSelect from './OptionDirectionSelect';
import BrokerageSelect from './BrokerageSelect';
import AccountNumberSelect from './AccountNumberSelect';
import EntryTypeSelect from './EntryTypeSelect';
import QtyValueTextField from '../../../../forms/tradeplans/quicktrade/QtyValueTextField';
import Grid from '@material-ui/core/Grid';
import CandleBreakTextFields from '../../../../forms/tradeplans/quicktrade/CandleBreakTextFields';
import NearestOtmItm from './NearestOtmItm';
import MaxOptionPriceTextField from './MaxOptionPriceTextField';
import ExpirationWeeksAway from './ExpirationWeeksAway';
import DataSourceSelect from './DataSourceSelect';
import NotExpiringTodayCheckBox from './NotExpiringTodayCheckBox';
import { WorkOrdersQuickTrade } from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/workOrders/WorkOrders';
import { ApplyChangesModal } from '../applyChangesModal/ApplyChangesModal';

const useStyles = makeStyles((theme) => ({
  root: {
    spacing: theme.spacing(10),
    border: '1px solid',
  },
  paper: {
    width: '45%',
  },
}));

export default function QuickTradesUserPreferencesMenu({
  userPreferences,
  receivedUserPreferences,
}) {
  const classes = useStyles();
  const [openQtPreferences, setOpenQtPreferences] = useState(false);
  const [openApplyChangesModal, setOpenApplyChangesModal] = useState(false);

  const {
    userPreferences: userPrefs,
    quickTrade: {
      instrument,
      setInstrument,
      quantityBasis,
      setQuantityBasis,
      quantityBasisValue,
      setQuantityBasisValue,
      accountNumber,
      setAccountNumber,
      dataSource,
      setDataSource,
      brokerage,
      setBrokerage,
      optionDirection,
      setOptionDirection,
      entryType,
      setEntryType,
      limitOrder,
      dispatchLimitOrder,
      candleBreak,
      dispatchCandleBreak,
      Break,
      dispatchBreak,
      nearestOtmItm,
      setNearestOtmItm,
      maxOptionPrice,
      setMaxOptionPrice,
      expirationWeeksAway,
      setExpirationWeeksAway,
      optionNotExpiringToday,
      setOptionNotExpiringToday,
      workOrder,
      setWorkOrder,
      pctIncreasePerOrderAttempt,
      setPctIncreasePerOrderAttempt,
      pctBetweenBidAsk,
      setPctBetweenBidAsk,
      getAwayOffsetPct,
      setGetAwayOffsetPct,
    },
  } = userPreferences;
  //console.log("option not expiring today: " + optionNotExpiringToday);
  return (
    <>
      <ApplyChangesModal
        open={openApplyChangesModal}
        handleClose={() => {
          setOpenApplyChangesModal(false);
          setOpenQtPreferences(false);
        }}
        userPrefs={userPrefs}
      />
      <ListItem button>
        <ListItemText
          onClick={() => setOpenQtPreferences(!openQtPreferences)}
          primary="Quick Trade"
        />
      </ListItem>
      <Drawer
        disableEnforceFocus
        anchor="right"
        open={openQtPreferences}
        onClose={() => {
          setOpenApplyChangesModal(true);
        }}
        classes={{ paper: classes.paper }}
      >

        <Box style={{ padding: 10 }}>
          <InstrumentSelect
            instrument={instrument}
            setInstrument={setInstrument}
          />
          {instrument === 'option' ? (
            <OptionDirectionSelect
              optionDirection={optionDirection}
              setOptionDirection={setOptionDirection}
            />
          ) : (
            <></>
          )}
          <BrokerageSelect
            brokerage={brokerage}
            setBrokerage={setBrokerage}
            dataSource={dataSource}
          />
          <AccountNumberSelect
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            dataSource={dataSource}
            brokerage={brokerage}
          />
          <DataSourceSelect
            dataSource={dataSource}
            setDataSource={setDataSource}
            setAccountNumber={setAccountNumber}
            setBrokerage={setBrokerage}
          />
          <WorkOrdersQuickTrade
            workOrder={workOrder}
            setWorkOrder={setWorkOrder}
            getAwayOffsetPct={getAwayOffsetPct}
            setGetAwayOffsetPct={setGetAwayOffsetPct}
            pctBetweenBidAsk={pctBetweenBidAsk}
            setPctBetweenBidAsk={setPctBetweenBidAsk}
            pctIncreasePerOrderAttempt={pctIncreasePerOrderAttempt}
            setPctIncreasePerOrderAttempt={setPctIncreasePerOrderAttempt}
          />
          <QuantityBasisSelect
            quantityBasis={quantityBasis}
            setQuantityBasis={setQuantityBasis}
          />
          <EntryTypeSelect entryType={entryType} setEntryType={setEntryType} />
          <Grid item container>
            <Grid item xs={12}>
              <FormLabel>
                <Typography style={{ fontSize: 10 }}>Entry Tactic:</Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={2}>
              <QtyValueTextField
                qtyBasisValue={quantityBasisValue}
                setQtyBasisValue={setQuantityBasisValue}
              />
            </Grid>

            {entryType === 'LIMIT_ORDER' ? (
              /* cant know limit price in advance....
                           <Grid item xs={4}>
                                <LimitOrderTextFields limitOrder={limitOrder} dispatchLimitOrder={dispatchLimitOrder}/>
                            </Grid> */
              <></>
            ) : entryType === 'CANDLE_BREAK' ? (
              <Grid item xs={10}>
                <CandleBreakTextFields
                  candleBreak={candleBreak}
                  dispatchCandleBreak={dispatchCandleBreak}
                />
              </Grid>
            ) : entryType === 'BREAK' ? (
              <></>
            ) : (
              /*<Grid item xs={2}>
                                        <BreakTextFields breakPrice={Break}
                                                         dispatchBreak={dispatchBreak}/>
                                    </Grid>*/
              <></>
            )}
          </Grid>
          <NearestOtmItm
            nearestOtmItm={nearestOtmItm}
            setNearestOtmItm={setNearestOtmItm}
          />
          <Grid item container direction="row">
            <Grid item xs={3}>
              <MaxOptionPriceTextField
                maxOptionPrice={maxOptionPrice}
                setMaxOptionPrice={setMaxOptionPrice}
              />
            </Grid>
            <Grid item xs={3}>
              <NotExpiringTodayCheckBox
                notExpiringToday={optionNotExpiringToday}
                setNotExpiringToday={setOptionNotExpiringToday}
              />
            </Grid>
            <Grid item xs={7}>
              <ExpirationWeeksAway
                expirationWeeksAway={expirationWeeksAway}
                setExpirationWeeksAway={setExpirationWeeksAway}
              />
            </Grid>
          </Grid>
        </Box>
      </Drawer>
    </>
  );
}
